﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateVehicle = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const StatePaged_1 = require("../abstracts/StatePaged");
const models_1 = require("../../api/admin/classes/models");
const gs_1 = require("@ivanlog/gs");
const StateVehicles_1 = require("./StateVehicles");
class StateVehicle extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageVehicle, "Vehicle", true);
        this.page.ctrls.btnSave.onclick = () => this.trySave();
        this.page.ctrls.btnDelete.onclick = () => this.tryDelete();
    }
    start(args) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (args) {
                if (args instanceof models_1.Vehicle)
                    this._vehicle = args;
                else if (args.id) {
                    this._vehicle = yield this.lockgui(this.app.api.admin.directory.getVehicle(args.id));
                    if (!this._vehicle)
                        return gs_1.StateRunResultEnum.Failed;
                }
            }
            if (this._vehicle)
                this._urlArgs["id"] = this._vehicle.id.toString();
            yield this.fill();
            return _super.start.call(this);
        });
    }
    fill() {
        return __awaiter(this, void 0, void 0, function* () {
            this.page.ctrls.btnDelete.show();
            var ctrl = this.page.ctrls;
            if (this._vehicle) {
                yield ctrl.form.fillFormData(this._vehicle, true);
                const vt = yield this.app.astra.getVehiclesType(this._vehicle.vehicleTypeId);
                const btn = gs.html.tag('button', { class: `${gs_1.ItemButton.TagClassName} no-active selected` }, vt.name.en);
                ctrl.rbType.append(btn);
                ctrl.iGovNumber.addClass('no-active');
                ctrl.iModel.addClass('no-active');
                ctrl.iColor.addClass('no-active');
            }
            else {
                this.page.ctrls.btnDelete.hide();
                const types = yield this.app.astra.getVehiclesTypes();
                if (types)
                    for (const vt of types) {
                        const btn = gs.w(gs.html.tag("button", { class: `${gs_1.ItemButton.TagClassName}` }, vt.name.en));
                        btn.setData(gs_1.ItemButton.TagDataValue, vt.id.toString());
                        this.page.ctrls.rbType.append(btn);
                    }
            }
        });
    }
    afterStart() {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.afterStart.call(this);
            if (this._vehicle)
                this.setLabel(this.title + ` #${this._vehicle.id} ${this._vehicle.govNumber}`);
        });
    }
    trySave() {
        return __awaiter(this, void 0, void 0, function* () {
            var data = yield this.page.ctrls.form.getFormData();
            if (!data)
                return;
            let vehicle;
            if (this._vehicle) {
                const req = new models_1.UpdateVehicleRequest(data);
                req.vehicleId = this._vehicle.id;
                vehicle = yield this.lockgui(this.app.api.admin.directory.updateVehicle(req));
                if (!vehicle)
                    return;
                yield new modalCom.DialogOk("Vehicle updated").show();
            }
            else {
                const req = new models_1.CreateVehicleRequest(data);
                req.typeId = parseInt(this.page.ctrls.rbType.value);
                if (!req.typeId) {
                    yield new modalCom.DialogOk("Need select vehicles type").show();
                    return;
                }
                vehicle = yield this.lockgui(this.app.api.admin.directory.createVehicle(req));
                if (!vehicle)
                    return;
                yield new modalCom.DialogOk("Vehicle created").show();
                yield gs_1.StateGS.Run(StateVehicles_1.StateVehicles);
            }
        });
    }
    tryDelete() {
        return __awaiter(this, void 0, void 0, function* () {
            const responce = yield this.lockgui(this.app.api.admin.directory.deleteVehicle(this._vehicle.id));
            if (!responce)
                return;
            yield new modalCom.DialogOk("Vehicle deleted").show();
            yield gs_1.StateGS.Run(StateVehicles_1.StateVehicles);
        });
    }
}
exports.StateVehicle = StateVehicle;
StateVehicle.StateName = "vehicle";
//# sourceMappingURL=StateVehicle.js.map